import { Form, Modal, Space, Switch } from 'antd';
import { useCallback } from 'react';

import styles from './UserPreferencesDialog.module.css';

import { Spinner } from '../../../_shared/Spinner';
import { UserPreferencesModalModel } from '../models/user-preferences';

export interface UserPreferencesDelegate {
  onOpenUserPreferences(): Promise<void>;

  onCancelUserPreferences(): void;

  onSaveUserPreferences(): Promise<void>;

  onEditStaleInstancesAlertsEnabled(checked: boolean): void;
}

export function UserPreferencesDialog({ model, delegate }: { model: UserPreferencesModalModel; delegate: UserPreferencesDelegate }) {
  const handleCancel = useCallback(() => delegate.onCancelUserPreferences(), [delegate]);
  const handleConfirm = useCallback(() => delegate.onSaveUserPreferences(), [delegate]);

  return (
    <Modal title="Preferences" maskClosable={false} open onCancel={handleCancel} onOk={handleConfirm} okText="Save" destroyOnClose>
      {model.loading && <Spinner />}

      {!model.loading && (
        <Space direction="vertical" className="w-full" size="middle">
          <div className={styles.preferencesContainer}>
            <strong>Notifications</strong>
            <div>
              With this option enabled, alerts will be sent via email to your email address when any instance is approaching its idle
              timeout and when it is automatically paused.
            </div>
            <Form.Item label="Stale instance email alerts" className={styles.preferenceItem}>
              <Switch
                aria-label="Stale instance email alerts enabled?"
                checked={model.preferences?.staleInstancesAlertsEnabled}
                onChange={(checked) => delegate.onEditStaleInstancesAlertsEnabled(checked)}
              />
            </Form.Item>
          </div>
        </Space>
      )}
    </Modal>
  );
}
